<template>
  <v-row class="ma-0" align="center" justify="center">
    <v-col cols="12" class="pa-0">
      <v-textarea
        :label="label"
        v-model="tempEvent.memo"
        outlined
        :rows="attach ? 4 : 8"
        @keyup="onUpdate"
        :rules="rules"
        :disabled="type == 'view'"
        hide-details>
      </v-textarea>
    </v-col>

    <template v-if="attach">
      <v-col cols="12" class="pa-0">
        <template v-for="(file, index) in attaches">
          <v-row :key="index" class="ma-0" align="center">
            <v-col cols="1" class="py-0 pl-0 pr-1" align="center">
              <v-icon small>{{ $MIMEICON[file.mime] }}</v-icon>
            </v-col>
            <v-col cols="7" class="py-0 px-1">
              <v-chip x-small color="secondary" outlined @click.stop="onClick(file)">
                <span class="overflow-text-hidden">{{ file.name }}</span>
              </v-chip>
            </v-col>
            <v-col cols="4" class="pa-0" align="end">
              <span class="caption">{{ file.size }}</span>
              <v-btn v-if="type != 'view'" icon small class="pa-0 ma-0" @click="onRemove(index, file)"><v-icon>mdi-close-circle-outline</v-icon></v-btn>
            </v-col>
          </v-row>
        </template>
        <v-row v-if="attaches.length < 3 && type != 'view'" class="ma-0" align="center">
          <v-spacer></v-spacer>
          <v-btn icon small class="pa-0 ma-0" @click="onFile()">
            <v-icon small color="success">mdi-paperclip</v-icon>
            <input @change="select" type="file" name="file" accept="image/png, image/jpeg, application/pdf" ref="file">
          </v-btn>
        </v-row>
      </v-col>
    </template>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import Vue from 'vue'

export default {
  computed: {
    attaches () {
      var temp = []
      for (var i in this.tempEvent.attaches) {
        var payload = JSON.parse(JSON.stringify(this.tempEvent.attaches[i]))
        payload['type'] = 'stored'
        temp.push(payload)
      }
      for (i in this.tempFiles) {
        payload = this.tempFiles[i]
        payload['type'] = 'upload'
        temp.push(payload)
      }
      return temp
    }
  },
  props: ['event', 'label', 'rules', 'attach', 'files', 'type'],
  data () {
    return {
      loading: false,
      tempEvent: null,
      tempFiles: []
    }
  },
  watch: {
    event () {
      this.tempEvent = JSON.parse(JSON.stringify(this.event))
    },
    files () {
      this.tempFiles = this.files
      if (this.files.length === 0 && typeof this.$refs.file !== 'undefined') {
        this.$refs.file.value = null
      }
    }
  },
  created () {
    this.tempEvent = JSON.parse(JSON.stringify(this.event))
    this.tempFiles = this.files
  },
  methods: {
    onClick (file) {
      if (file.path) {
        window.open(file.path, '_blank')
      } else {
        window.open(URL.createObjectURL(file.blob), '_blank')
      }
    },
    onUpdate () {
      this.$emit('update', { item: JSON.parse(JSON.stringify(this.tempEvent)), files: this.tempFiles })
    },
    onRemove (index, file) {
      if (this.attaches[index].type === 'stored') {
        var offset = this.tempEvent.attaches.findIndex(a => a.path === this.attaches[index].path)
        if (offset !== -1) {
          this.tempEvent.attaches.splice(offset, 1)
        }
      } else {
        offset = this.tempFiles.findIndex(t => t.name === file.name)
        if (offset !== -1) {
          this.tempFiles.splice(offset, 1)
          if (typeof this.$refs.file !== 'undefined') {
            this.$refs.file.value = null
          }
        }
      }
      this.onUpdate()
    },
    onFile () {
      this.$refs.file.click()
    },
    async select (e) {
      this.loading = true
      this.fileRead(e)
    },
    fileRead (e) {
      var vm = this
      e.preventDefault()
      const files = e.target.files
      if (files.length !== 0) {
        var index = this.tempFiles.length
        Vue.set(this.tempFiles, index, { blob: files[0], name: files[0].name, mime: files[0].type, size: this.returnFileSize(files[0].size) })
        var reader = new FileReader()
        reader.onerror = function () {
          vm.loading = false
        }
        reader.onload = function () {
          vm.onUpdate()
          vm.loading = false
        }
        reader.readAsArrayBuffer(vm.tempFiles[index].blob)
      } else {
        this.loading = false
      }
    },
    returnFileSize (number) {
      if (number < 1024) {
        return number + 'bytes'
      } else if (number >= 1024 && number < 1048576) {
        return (number / 1024).toFixed(1) + 'KB'
      } else if (number >= 1048576) {
        return (number / 1048576).toFixed(1) + 'MB'
      }
    }
  }
}
</script>

<style>
input[type="file"] {
  display: none;
}
</style>
